module.exports = __webpack_public_path__ + "static/media/person-placeholder.69e06d9c.jpg";